import { memo } from 'react';
import { ScrollView } from 'react-native';
import styled from 'styled-components/native';

import { useOrientation } from '../../../boot/OrientationContext';
import { GET_LAYOUT_MAX_WIDTH } from '../../../constants/layout';
import Image from '../../../elements/Image';
import { translate } from '../../../i18n';

export default memo(function EmptyReview() {
  useOrientation();

  const ImageSize = GET_LAYOUT_MAX_WIDTH() / 1.3;

  return (
    <ScrollView>
      <S.Container>
        <S.ImageContainer size={ImageSize}>
          <S.Image
            size={ImageSize}
            source={require('./assets/img_empty_rating.png')}
          />
        </S.ImageContainer>
        <S.EmptyDesc>{translate('review-section-empty')}</S.EmptyDesc>
      </S.Container>
    </ScrollView>
  );
});

const S = {
  Container: styled.View`
    align-items: center;
    flex-direction: column;
    margin: 20px 0;
  `,
  ImageContainer: styled.View<{ size: number }>`
    border-radius: 3px;
    height: ${({ size }) => size}px;
    margin: 10px 0;
    overflow: hidden;
    width: ${({ size }) => size}px;
  `,
  Image: styled(Image)<{ size: number }>`
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;
  `,
  EmptyDesc: styled.Text`
    color: ${({ theme }) => theme.palette.neutralDark};
    font-size: 15px;
    line-height: 21px;
  `,
};
